import { connect } from 'react-redux';
import { branch, renderComponent, compose } from 'recompose';
import Loader from '../components/Loader';

const WithLoader = branch(
  props => props.isFetching,
  renderComponent(Loader),
);
const mapStateToProps = (state, ownProps) => ({
  isFetching: ownProps.isLoading || state.app.get('isFetching'),
});

export default compose(
  connect(mapStateToProps),
  WithLoader,
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithLoader.js